import React from 'react';
import { TicketsPagination } from '../TicketsView/componentes';
import { useTicketsReport } from './hooks/useTicketsReport';
import {
    ReportHeader,
    ReportKpiCards,
    ReportFilterBar,
    ReportTable
} from './componentes';

const TicketsReportView = ({ onSelectTicket }) => {
    const {
        tickets,
        filteredTickets,
        totalRegistros,
        totalPages,
        counts,
        isLoading,
        isExporting,
        statusFilter,
        selectedAgentId,
        dateFilter,
        searchTerm,
        setSearchTerm,
        page,
        setPage,
        pageSize,
        setPageSize,
        agents,
        isLoadingAgents,
        idUsuario,
        nombreCompleto,
        handleStatusChange,
        handleDateChange,
        handleAgentChange,
        handleExportPdf
    } = useTicketsReport();

    return (
        <div className="tickets-report-container p-3">
            {/* Encabezado y Acción de Exportar PDF (solo en escritorio) */}
            <div className="d-none d-md-block">
                <ReportHeader
                    onExportPdf={handleExportPdf}
                    isExporting={isExporting}
                    isLoading={isLoading}
                    totalRegistros={totalRegistros}
                />
            </div>

            {/* 1. Vista Móvil: Filtros arriba de los KPI cards */}
            <div className="d-md-none">
                <ReportFilterBar
                    isMobile={true}
                    statusFilter={statusFilter}
                    onStatusChange={handleStatusChange}
                    counts={counts}
                    dateFilter={dateFilter}
                    onDateChange={handleDateChange}
                    selectedAgentId={selectedAgentId}
                    onAgentChange={handleAgentChange}
                    agents={agents}
                    idUsuario={idUsuario}
                    nombreCompleto={nombreCompleto}
                    isLoadingAgents={isLoadingAgents}
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    onExportPdf={handleExportPdf}
                    isExporting={isExporting}
                    totalRegistros={totalRegistros}
                />
            </div>

            {/* KPI Cards de Resumen */}
            <ReportKpiCards
                counts={counts}
                activeStatus={statusFilter}
                onSelectStatus={handleStatusChange}
            />

            {/* 2. Vista Escritorio: Filtros debajo de los KPI cards */}
            <div className="d-none d-md-block">
                <ReportFilterBar
                    isMobile={false}
                    statusFilter={statusFilter}
                    onStatusChange={handleStatusChange}
                    counts={counts}
                    dateFilter={dateFilter}
                    onDateChange={handleDateChange}
                    selectedAgentId={selectedAgentId}
                    onAgentChange={handleAgentChange}
                    agents={agents}
                    idUsuario={idUsuario}
                    nombreCompleto={nombreCompleto}
                    isLoadingAgents={isLoadingAgents}
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    onExportPdf={handleExportPdf}
                    isExporting={isExporting}
                    totalRegistros={totalRegistros}
                />
            </div>

            {/* Tabla de Resultados */}
            <ReportTable
                tickets={filteredTickets}
                isLoading={isLoading}
                totalTicketsCount={tickets.length}
                onSelectTicket={onSelectTicket}
            />

            {/* Paginación */}
            <TicketsPagination
                currentPage={page}
                totalPages={totalPages}
                totalRecords={totalRegistros}
                pageSize={pageSize}
                onPageChange={setPage}
                onPageSizeChange={size => {
                    setPageSize(size);
                    setPage(1);
                }}
                isLoading={isLoading}
            />
        </div>
    );
};

export default TicketsReportView;